module.exports = __webpack_public_path__ + "img/ks-HIbah-Pendapatan-Sales-Tool-Rev-1-pdf.6cc6ae00.jpeg";